export default __webpack_public_path__ + "static/media/sunny.95dab889.svg";